import { render, staticRenderFns } from "./TicketInboundTextMessage.vue?vue&type=template&id=1c2eed55&scoped=true&"
import script from "./TicketInboundTextMessage.vue?vue&type=script&lang=js&"
export * from "./TicketInboundTextMessage.vue?vue&type=script&lang=js&"
import style0 from "./TicketInboundTextMessage.vue?vue&type=style&index=0&id=1c2eed55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2eed55",
  null
  
)

export default component.exports